import { render, staticRenderFns } from "./charity.vue?vue&type=template&id=1bb02196&"
import script from "./charity.vue?vue&type=script&lang=js&"
export * from "./charity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports